// extracted by mini-css-extract-plugin
export default {"userUtterance":"UserMessage-module__userUtterance--U4bt1","userUtteranceBubble":"UserMessage-module__userUtteranceBubble--LTnjC"};